import {
	RefObject,
	forwardRef,
	ReactNode,
	FormEventHandler,
	KeyboardEventHandler,
} from 'react';

interface FormProps {
	id?: string;
	className?: string;
	children: ReactNode;
	ref: RefObject<HTMLFormElement>;
	handleSubmit?: FormEventHandler<HTMLFormElement> | undefined;
	handleKeyDown?: KeyboardEventHandler<HTMLFormElement> | undefined;
}

export const Form = forwardRef<HTMLFormElement, FormProps>((props, ref) => {
	return (
		<form
			ref={ref}
			id={props.id}
			autoComplete="off"
			onSubmit={props.handleSubmit}
			onKeyDown={props.handleKeyDown}
			className={`space-y-8 ${props.className && props.className}`}
		>
			{props.children}
		</form>
	);
});
